import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import SmsTemplates from "@/pages/Pages/SMS/SmsTemplates.vue";
import SmsTemplate from "@/pages/Pages/SMS/SmsTemplate.vue";
import SmsDetail from "@/pages/Pages/SMS/SmsDetail.vue";
import SmsDetailInfo from "@/pages/Pages/SMS/SmsDetailInfo.vue";
import SmsGroup from "@/pages/Pages/SMS/SmsGroup.vue";
import SmsOperatorTariffZones from "@/pages/Pages/SMS/SmsOperatorTariffZones.vue";
import SmsOperatorTariffZone from '@/pages/Pages/SMS/SmsOperatorTariffZone.vue';
import SmsOperatorTariffZoneGroup from '@/pages/Pages/SMS/SmsOperatorTariffZoneGroup.vue';
import SmsPartnerTariffZones from "@/pages/Pages/SMS/SmsPartnerTariffZones.vue";
import SmsPartnerTariffZone from '@/pages/Pages/SMS/SmsPartnerTariffZone.vue';
import SmsPartnerTariffZoneGroup from '@/pages/Pages/SMS/SmsPartnerTariffZoneGroup.vue';
import SmsOriginatorRules from "@/pages/Pages/SMS/SmsOriginatorRules.vue";
import SmsOriginatorRule from "@/pages/Pages/SMS/SmsOriginatorRule.vue";
import SmsFilters from "@/pages/Pages/SMS/SmsFilters.vue";
import SmsFilter from '@/pages/Pages/SMS/SmsFilter.vue';
import SmsGroupIncoming from "@/pages/Pages/SMS/SmsGroupIncoming.vue";
import SmsDetailIncoming from "@/pages/Pages/SMS/SmsDetailIncoming.vue";
import SmsDetailIncomingInfo from "@/pages/Pages/SMS/SmsDetailIncomingInfo.vue";
import OriginatorRestrictions from "@/pages/Pages/SMS/OriginatorRestrictions.vue";
import OriginatorRestriction from "@/pages/Pages/SMS/OriginatorRestriction.vue";
import SmsIncomingTariffs from '@/pages/Pages/SMS/SmsIncomingTariffs.vue';
import SmsIncomingTariff from '@/pages/Pages/SMS/SmsIncomingTariff.vue';

let smsMenu = {
  path: "/sms",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  redirect: "/sms/templates",
  name: "SMS",
  children: [
    {
      path: "templates",
      name: "sms_templates",
      components: { default: SmsTemplates },
      meta:{
        icon: "sms",
        msgKey: 'menu.item.sms.templates'
      }
    },
    {
      path: "templates/new",
      name: "sms_templates_new",
      components: { default: SmsTemplate },
      meta:{
        icon: "sms",
        parentPath: "/sms/templates",
        msgKey: 'menu.item.sms.templates'
      },
    },
    {
      path: "templates/:id",
      name: "sms_templates_edit",
      components: { default: SmsTemplate },
      meta:{
        icon: "sms",
        parentPath: "/sms/templates",
        msgKey: 'menu.item.sms.templates'
      }
    },
    {
      path: "detail",
      name: "sms_detail",
      components: { default: SmsDetail },
      meta:{
        icon: "sms",
        msgKey: 'menu.item.statistics.sms.detail'
      }
    },
    {
      path: "detail/:id",
      name: "sms_detail_info",
      components: { default: SmsDetailInfo },
      meta:{
        icon: "sms",
        parentPath: "/sms/detail",
        msgKey: 'menu.item.statistics.sms.detail'
      }
    },
    {
      path: "group",
      name: "sms_group",
      components: { default: SmsGroup },
      meta:{
        icon: "sms",
        msgKey: 'menu.item.statistics.sms.group'
      }
    },
    {
      path: "tarification/partners",
      name: "sms_tarification_partners",
      components: { default: SmsPartnerTariffZones },
      meta:{
        icon: "sms",
        msgKey: 'menu.item.sms.clients.routing'
      }
    },
    {
      path: "tarification/partners/:partner_id/tariff_zone_group",
      name: "sms_tarification_partners_group",
      components: { default: SmsPartnerTariffZoneGroup },
      meta:{
        icon: "sms",
        parentPath: "/sms/tarification/partners",
        msgKey: 'menu.item.sms.clients.routing'
      }
    },
    {
      path: "tarification/partners/:partner_id/tariff_zone/new",
      name: "sms_tarification_partners_new",
      components: { default: SmsPartnerTariffZone },
      meta:{
        icon: "sms",
        parentPath: "/sms/tarification/partners",
        msgKey: 'menu.item.sms.clients.routing'
      }
    },
    {
      path: "tarification/partners/:partner_id/tariff_zone/:id",
      name: "sms_tarification_partners_edit",
      components: { default: SmsPartnerTariffZone },
      meta:{
        icon: "sms",
        parentPath: "/sms/tarification/partners",
        msgKey: 'menu.item.sms.clients.routing'
      }
    },
    {
      path: "tarification/service_providers",
      name: "sms_tarification_operators",
      components: { default: SmsOperatorTariffZones },
      meta:{
        icon: "sms",
        msgKey: 'menu.item.sms.provider.routing'
      }
    },
    {
      path: "tarification/service_providers/:operator_id/tariff_zone_group",
      name: "sms_tarification_operators_group",
      components: { default: SmsOperatorTariffZoneGroup },
      meta:{
        icon: "sms",
        parentPath: "/sms/tarification/service_providers",
        msgKey: 'menu.item.sms.provider.routing'
      }
    },
    {
      path: "tarification/service_providers/:operator_id/tariff_zone/new",
      name: "sms_tarification_operators_new",
      components: { default: SmsOperatorTariffZone },
      meta:{
        icon: "sms",
        parentPath: "/sms/tarification/service_providers",
        msgKey: 'menu.item.sms.provider.routing'
      }
    },
    {
      path: "tarification/service_providers/:operator_id/tariff_zone/:id",
      name: "sms_tarification_operators_edit",
      components: { default: SmsOperatorTariffZone },
      meta:{
        icon: "sms",
        parentPath: "/sms/tarification/service_providers",
        msgKey: 'menu.item.sms.provider.routing'
      }
    },
    {
      path: "originator_rules",
      name: "sms_originator_rules",
      components: { default: SmsOriginatorRules },
      meta:{
        icon: "sms",
        msgKey: 'menu.item.sms.pool.rules'
      }
    },
    {
      path: "originator_rules/new",
      name: "sms_originator_rules_new",
      components: { default: SmsOriginatorRule },
      meta:{
        icon: "sms",
        parentPath: "/sms/originator_rules",
        msgKey: 'menu.item.sms.pool.rules'
      },
    },
    {
      path: "originator_rules/:id",
      name: "sms_originator_rules_edit",
      components: { default: SmsOriginatorRule },
      meta:{
        icon: "sms",
        parentPath: "/sms/originator_rules",
        msgKey: 'menu.item.sms.pool.rules'
      }
    },
    {
      path: "filters",
      name: "sms_filters",
      components: { default: SmsFilters },
      meta:{
        icon: "sms",
        msgKey: 'menu.item.sms.filter'
      }
    },
    {
      path: "filters/new",
      name: "sms_filters_new",
      components: { default: SmsFilter },
      meta: {
        icon: "sms",
        parentPath: "/sms/filters",
        msgKey: 'menu.item.sms.filter'
      },
    },
    {
      path: "filters/:id",
      name: "sms_filters_edit",
      components: { default: SmsFilter },
      meta:{
        icon: "sms",
        parentPath: "/sms/filters",
        msgKey: 'menu.item.sms.filter'
      }
    },
    {
      path: "restrictions",
      name: "originator_restrictions",
      components: { default: OriginatorRestrictions },
      meta:{
        icon: "sms",
        msgKey: 'menu.item.sms.originators'
      }
    },
    {
      path: "restrictions/new",
      name: "originator_restrictions_new",
      components: { default: OriginatorRestriction },
      meta: {
        icon: "sms",
        parentPath: "/sms/restrictions",
        msgKey: 'menu.item.sms.originators'
      },
    },
    {
      path: "restrictions/:id",
      name: "originator_restrictions_edit",
      components: { default: OriginatorRestriction },
      meta:{
        icon: "sms",
        parentPath: "/sms/restrictions",
        msgKey: 'menu.item.sms.originators'
      }
    },
    {
      path: "incoming_tariffs",
      name: "sms_incoming_tariffs",
      components: { default: SmsIncomingTariffs },
      meta:{
        icon: "sms",
        msgKey: 'menu.item.sms.mo.routing'
      }
    },
    {
      path: "incoming_tariffs/new",
      name: "sms_incoming_tariffs_new",
      components: { default: SmsIncomingTariff },
      meta: {
        icon: "sms",
        parentPath: "/sms/incoming_tariffs",
        msgKey: 'menu.item.sms.mo.routing'
      },
    },
    {
      path: "incoming_tariffs/:id",
      name: "sms_incoming_tariffs_edit",
      components: { default: SmsIncomingTariff },
      meta:{
        icon: "sms",
        parentPath: "/sms/incoming_tariffs",
        msgKey: 'menu.item.sms.mo.routing'
      }
    },
    {
      path: "detail_incoming",
      name: "sms_detail_incoming",
      components: { default: SmsDetailIncoming },
      meta: {
        icon: "sms",
        msgKey: 'menu.item.statistics.sms.mo.detail'
      }
    },
    {
      path: "detail_incoming/:id",
      name: "sms_detail_incoming_info",
      components: { default: SmsDetailIncomingInfo },
      meta:{
        icon: "sms",
        parentPath: "/sms/detail_incoming",
        msgKey: 'menu.item.statistics.sms.detail'
      }
    },
    {
      path: "group_incoming",
      name: "sms_group_incoming",
      components: { default: SmsGroupIncoming },
      meta: {
        icon: "sms",
        msgKey: 'menu.item.statistics.sms.mo.group'
      }
    }
  ]
};

export default smsMenu;
